import { CustomStringParam, FilterType, SchemaFilterType } from '@ui/src';

export const columns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'locked',
    label: 'Locked',
    sortable: false,
  },
  {
    name: 'createdAt',
    label: 'Created Date',
    sortable: false,
  },
  {
    name: 'expiresAt',
    label: 'Expires date',
    sortable: false,
  },
  {
    name: 'userId',
    label: 'User ID',
    sortable: false,
  },
  {
    name: 'reason',
    label: 'Reason',
    sortable: false,
  },
  {
    name: 'createdByEmployeeId',
    label: 'Created by Employee',
    sortable: false,
  },
  {
    name: 'type',
    label: 'Creation type',
    sortable: false,
  },
  {
    name: 'createdByComment',
    label: 'Comment',
    sortable: false,
  },
];

export const columnsLabels = {
  locked: 'Locked',
  reason: 'Reason',
  userId: 'User ID',
  type: 'Creation type',
  createdByEmployeeId: 'Created by Employee',
};

export const schema = {
  locked: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  reason: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  userId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  type: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  createdByEmployeeId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  createdAt: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
    queryNames: ['createdAtFrom', 'createdAtTo'],
  },
  createdAtFrom: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
  },
  createdAtTo: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
  },
  expiresAt: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
    queryNames: ['expiresAtFrom', 'expiresAtTo'],
  },
  expiresAtFrom: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
  },
  expiresAtTo: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
  },
};

export const filtersSchema = [
  {
    name: 'type',
    type: FilterType.RADIO,
    withClearButton: true,
    fields: [
      {
        name: 'type',
        title: 'Auto',
        value: 'AUTO',
      },
      {
        name: 'type',
        title: 'by Employee',
        value: 'MANUAL',
      },
    ],
  },
  {
    name: 'locked',
    type: FilterType.RADIO,
    withClearButton: true,
    fields: [
      {
        name: 'locked',
        title: 'Yes',
        value: 'true',
      },
      {
        name: 'locked',
        title: 'No',
        value: 'false',
      },
    ],
  },
  {
    name: 'userId',
    type: FilterType.TEXT,
    placeholder: 'Enter User ID...',
  },
  {
    name: 'createdByEmployeeId',
    type: FilterType.AUTOCOMPLETE,
    placeholder: 'Search by Employee...',
  },
  {
    name: 'reason',
    type: FilterType.AUTOCOMPLETE_MULTIPLE,
    placeholder: 'Enter reason...',
  },
];
